"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _abcjs = _interopRequireDefault(require("abcjs"));

require("./ScaleBuilder.css");

var _MusicEditor = _interopRequireWildcard(require("./MusicEditor"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback"));

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback"));

var _Button = _interopRequireDefault(require("react-bootstrap/Button"));

var _CompletedContext = require("../CompletedContext");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TaskScaleBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskScaleBuilder, _React$Component);

  var _super = (0, _createSuper2.default)(TaskScaleBuilder);

  function TaskScaleBuilder(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskScaleBuilder);
    _this = _super.call(this, props);

    _this.submitScale = function () {
      if (_this.state.notation === _this.props.correct) {
        _this.setState({
          correct: true,
          completed: true,
          notation: _this.state.notation
        });
      } else {
        _this.setState({
          correct: false,
          completed: true,
          showFeedback: true
        });
      }
    };

    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.notation = _this.props.notation;
    }

    _this.extractMetadata = _this.extractMetadata.bind((0, _assertThisInitialized2.default)(_this));
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.token = (0, _MusicEditor.generateToken)();
    _this.metadata = {
      question_id: "5ec2afb5b75c847595388176",
      music_configuration: _this.props.precursor,
      //'X:1;L:1/4;M:;K:C;V:1 treble up',
      music_initial: _this.props.notation_intital,
      music_button_note: "true",
      music_button_sharp: "true",
      music_button_flat: "true",
      music_button_natural: "false",
      music_button_double_sharp: "false",
      music_button_double_flat: "false",
      music_button_audio: "true",
      music_staff_wrap: "false",
      music_staff_width: "100%",
      music_duration: "2000"
    };
    return _this;
  }

  (0, _createClass2.default)(TaskScaleBuilder, [{
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.extractMetadata();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      console.log("task mount", this.state); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this3 = this;

      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }

      if (this.state.submission_number > 2 && !this.state.correct && !this.state.reset) {
        var parsedAnswer = _abcjs.default.parseOnly(this.precursor + this.state.answer.join(''));

        if (prevstate.submission_number !== this.state.submission_number) {
          var notationWithoutIncorrect = "";
          var notationArray = (0, _MusicEditor.serializeNotation)(this.state.notation);
          this.state.answer.forEach(function (correctNote, index) {
            if (correctNote === notationArray[index]) {
              notationWithoutIncorrect += correctNote;
            } else {
              notationWithoutIncorrect += "z";
            }
          });
          this.setState({
            notation: notationWithoutIncorrect
          });
        }

        var i = 0; //i corresponds to the actual html hotspot index, whereas index is for the abcjs parse object

        parsedAnswer[0].lines[0].staff[0].voices[0].forEach(function (note, index) {
          if (note.pitches) {
            var hotspot = document.getElementsByClassName(note.pitches[0].verticalPos)[i];

            if (prevstate.submission_number !== _this3.state.submission_number && _this3.state.submission_number === 3) {
              // eslint-disable-next-line
              _this3.state.notationRound3 = _this3.state.notation;
            }

            if (_this3.state.submission_number === 3) {
              var parsedNotation = _abcjs.default.parseOnly(_this3.precursor + _this3.state.notationRound3);

              if (parsedNotation[0].lines[0].staff[0].voices[0][index].pitches) {
                if (_this3.arraysAreIdentical(Object.values(note.pitches[0]), Object.values(parsedNotation[0].lines[0].staff[0].voices[0][index].pitches[0]))) {
                  hotspot.classList.add('green');
                  hotspot.classList.remove('staff-space', 'staff-line');
                }
              }
            } else {
              hotspot.classList.add('green');
              hotspot.classList.remove('staff-space', 'staff-line');

              if (note.pitches[0].accidental) {
                hotspot.correctAccidental = _MusicEditor.accidentals[note.pitches[0].accidental];
              }
            }

            i = i + 1;
          }
        });
      } else {
        var numOfGreens = document.getElementsByClassName('green').length;

        for (var _i2 = 0; _i2 < numOfGreens; _i2++) {
          var hotspot = document.getElementsByClassName('green')[0];
          hotspot.classList.remove('green');
          hotspot.classList.add('staff-space');
          hotspot.style.fill = "#0000ff";
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "App"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: this.metadata.music_staff_width
        }
      }, this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#f8d7da",
          borderRadius: "5px",
          border: "1px #f5c6cb solid"
        }
      }, "Your Submission:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, {
        ref: this.musiceditor,
        addClasses: true,
        addHotspots: !this.state.completed,
        monophonic: true,
        accidentals: true,
        millisecondsPerMeasure: parseInt(this.metadata.music_duration),
        zoom: 2,
        metadata: this.metadata,
        precursor: this.precursor,
        notation: this.state.notation,
        answer: this.state.answer,
        onChange: function onChange(newNotation) {
          _this4.setState({
            notation: newNotation
          });
        },
        completed: this.state.completed
      }), !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "sb-action-button",
        variant: "dark",
        disabled: this.state.correct,
        style: {
          float: 'right'
        },
        onClick: this.submitScale
      }, "Submit"))), this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: this.metadata.music_staff_width
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#d4edda",
          borderRadius: "5px",
          border: "1px c3e6cb solid"
        }
      }, "Correct Answer:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, {
        addClasses: true,
        addHotspots: !this.state.completed,
        monophonic: true,
        millisecondsPerMeasure: parseInt(this.metadata.music_duration),
        zoom: 2,
        metadata: this.metadata,
        precursor: this.precursor,
        notation: this.props.correct,
        answer: this.state.answer,
        onChange: function onChange(newNotation) {
          _this4.setState({
            notation: newNotation
          });
        },
        completed: this.state.completed
      })), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showFeedback && this.state.completed,
        onHide: function onHide() {
          _this4.setState({
            showFeedback: false
          });
        },
        buttonText: "Okay"
      }, "Incorrect. Please see the correct scale below your submission."), this.state.completed && this.state.correct && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        feedback: 'Correct! You have submitted the right scale.'
      }));
    }
  }, {
    key: "extractMetadata",
    value: function extractMetadata() {
      // let queryString = window.location.search.substring(1);
      // if(queryString){
      //   var metadata_in = JSON.parse(decodeURIComponent(queryString));
      //   Object.keys(metadata_in).forEach((key)=>{
      //     if(metadata_in[key])
      //       this.metadata[key] = metadata_in[key].replace(/\+/g, ' ');
      //   });
      // }
      // else{
      //   this.local = true;
      // }
      // 
      // if(this.metadata.music_initial === "")
      //   this.metadata.music_initial = 'zzzz'
      // this.setState({id: this.metadata.question_id, notation: this.metadata.music_initial});
      this.precursor = this.metadata.music_configuration;
      this.precursor = this.precursor.split(';').join('\n') + '\n';
    }
  }]);
  return TaskScaleBuilder;
}(_react.default.Component);

TaskScaleBuilder.contextType = _CompletedContext.CompletedContext;
var _default = TaskScaleBuilder;
exports.default = _default;